<template>
  <div class="projekter topspacing">
    <div class="grid-x content">
      <div class="small-8 cell">
        <span class="float-left"><i class="material-icons date-icon">date_range</i></span>
        <datepicker 
          v-model="state.date" 
          id="datepicker" 
          name="Datepicker" 
          language="da"
          placeholder="I dag"
          v-on:selected="getSelectedDate">
        </datepicker>
      </div>
      <div class="small-4 cell">
        <div class="user special-text text-right" @click="showUsers">
          <p>{{selectedUser.navn}} <i class="material-icons">keyboard_arrow_down</i></p>
          <div class="user-list" v-show="showUserList">
            <ul>
              <li v-for="user in users" v-bind:key="user.id" @click="selectUser(user)">
                {{user.navn}}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <ul class="list content" :class="{'hide-list': createNew}" v-show="filteredResult.length > 0">
      <li v-for="(project, index) in projectView" v-bind:key="project.id" @click="gotoProject(project)" >
        <div class="grid-x">
          <div class="small-1 cell">
            <div class="status dark-color" :class="classObject(project)"><span v-if="index < 9">0</span>{{index + 1}}</div>
          </div>
          <div class="small-6 cell">
            <span>{{project.bookingTypeNavn}}</span><br />
            <p v-if="!project.adresse.etage && !project.adresse.doer" class="small-text">{{project.adresse.vejnavn + ' ' +  project.adresse.husnummer + ', ' + project.adresse.postnummer + ' ' + project.adresse.by | shorten}}</p>
            <p v-if="project.adresse.etage && !project.adresse.doer" class="small-text">{{project.adresse.vejnavn + ' ' +  project.adresse.husnummer + '. ' + project.adresse.etage + ', ' + project.adresse.postnummer + ' ' + project.adresse.by | shorten}}</p>
            <p v-if="!project.adresse.etage && project.adresse.doer" class="small-text">{{project.adresse.vejnavn + ' ' +  project.adresse.husnummer + '. ' + project.adresse.doer + ', ' + project.adresse.postnummer + ' ' + project.adresse.by | shorten}}</p>
            <p v-if="project.adresse.etage && project.adresse.doer" class="small-text">{{project.adresse.vejnavn + ' ' +  project.adresse.husnummer + '. ' + project.adresse.etage + ' - ' + project.adresse.doer + ', ' + project.adresse.postnummer + ' ' + project.adresse.by | shorten}}</p>
          </div>
          <div class="small-4 cell padding-text">
            {{project.fratid | moment}} - {{project.tiltid | moment}}
          </div>
          <div class="small-1 cell icon-center">
            <i v-if="project.bemaerkning !== ''" class="material-icons note-icon">note</i>
          </div>
        </div>
      </li>
    </ul>
    <div class="placeholder" v-show="filteredResult.length == 0 || projectView == undefined">
      <div class="placeholder-image">
        <img src="./../assets/image/invoice.png" alt="projekt-ikon">
      </div>
        <h5>Ingen opgaver for den<br /> valgte dato eller montør</h5>
        <!-- <p class="tips"><b>Hint:</b> Ved at klikke på "I dag" eller<br />dato-ikonet i venstre hjørne, kan du skifte dato.</p> -->
      </div>
    </div>
</template>

<script>

var _ = require('lodash');
import Datepicker from 'vuejs-datepicker';
import DAL, {mongoObjectId} from './../js/Sync/dal';
import clearQueue from './../js/Sync/clearQueue';

var state = {
  date: ''
}

export default {
  name: 'projekter',
  props: ['reloadData'],
  components: {
    Datepicker
  },
  data() {
    return {
      selectedUser: '',
      projects: [],
      users: '',
      // Datepicker
      state: state,
      // Filtered
      filteredResult: [],
      createNew: false,
      showUserList: false
    }
  },
  computed: {
    projectView() {
      return this.filteredResult;
    }
  },
  watch: {
    reloadData(oldVal, val) {
      if (oldVal != val) {
        this.getTasksFromIDB(window['selectedDate'], window['user'].id);
      }
    }
  },
  methods: {
    classObject(item) {
      // console.log('item.nyMaalerStand !== null', item.nyMaalerStand !== null)
      // console.log('item.nyMaalerStand !== ""', item.nyMaalerStand !== "")
      // console.log('item.nytMaalernummer !== null', item.nytMaalernummer !== null)
      // console.log('item.nytMaalernummer !== ""', item.nytMaalernummer !== "")
      // console.log('item.sidsteaflaesning', item.sidsteaflaesning)
      // console.log('item.sidsteaflaesning > 0', item.sidsteaflaesning > 0)
      // console.log('item.sidsteaflaesning !== null', item.sidsteaflaesning !== null)
      // console.log('item.sidsteaflaesning !== ""', item.sidsteaflaesning !== "")
      // console.log('item.maalerStand !== undefined', item.maalerStand !== undefined)
      // console.log('item.nytidTypeId === undefined', item.nytidTypeId === undefined)
      // console.log('item.nytidTypeId === 0', item.nytidTypeId === 0)
      // console.log('item.nytidTypeId > 0', item.nytidTypeId > 0)
      // console.log('item end')
      
      if (item.maalerStand !== undefined && item.maalerStand !== "" && item.maalerStand !== null) {
        return {
          'green-color': true
        } 
      } else if ((item.nytMaalernummer !== null && item.nytMaalernummer !== "")) {     
          return false
      } else if (item.nytidTypeId > 0) {
        return {
          'red-color': true
        }
      } else {
        return false;
      }
    },
    gotoProject(project) {
      this.$router.push({
        name: 'projekt',
        params: { id: project.id }
      });
    },
    getSelectedDate(date) {
      if (date == undefined || date == "" || date == null ) {
        date = new Date();
      }
        var formatted = moment(date).format('YYYYMMDD');
        window['selectedDate'] = formatted;
        this.getTasksFromIDB(formatted, window['user'].id);
    },
    showUsers() {
      this.showUserList = !this.showUserList;
      //$('.user-list').toggle();
    },
    selectUser(user) {
      this.selectedUser = user;
      console.log('user', user)
      window['user'] = user;
      this.$cookie.delete('user');
      this.$cookie.set('user', JSON.stringify(window['user']), { expires: '20Y' });
      this.getSelectedDate(this.state.date);
    },
    getTasksFromIDB(selectedDate, selectedUserId) {
      var _this = this;
      var tasks = [];

      new Promise(function (resolve, reject) {
        if (selectedDate == null || selectedDate == undefined || selectedDate == '') {
          selectedDate =  moment(new Date()).format('YYYYMMDD');
        }
          DAL.iterate("MTTempData", function (value, key, iterationNumber) {
            var date = moment(value.fratid).format('YYYYMMDD');
            if (date.includes(selectedDate)) {
              if (value.montoerId == selectedUserId) {
                console.log("value", value)
                tasks.push(value);
              }
            }
          }).then(function () {
            return DAL.iterate("MTTasks", function (value, key, iterationNumber) {
              var date = moment(value.fratid).format('YYYYMMDD');
              if (date.includes(selectedDate)) {
                var tempTasks = tasks;
                var existsBool = false;
                if (value.montoerId == selectedUserId) {
                  tempTasks.forEach(function(item){
                    if(item.id === value.id){
                      existsBool = true;
                    }
                  });
                  if(!existsBool){
                    tasks.push(value);
                    existsBool = false;
                  }
                }
              }
            })
            .then(function () {
              resolve(tasks);
            })
          })

      }).then(function (result) {
        return new Promise(function (resolve, reject) {
          tasks.sort(function(a, b) {
            return new Date(a.fratid) - new Date(b.fratid);
          });
          if (selectedDate != null) {
            _this.projects = tasks;
            _this.sortByUser(tasks);
          } else {
            _this.projects = tasks;
          }
          resolve(tasks);
        })
      }).then(function () {
        _this.sortByUser(tasks);
      })
    },
    sortByUser(data) {
      this.filteredResult = [];
      for (var i = 0; i < data.length; i++) {
        if (data[i].montoerId == this.selectedUser.id) {
          this.filteredResult.push(data[i]);
        }
      }
    }
  },
  filters: {
    moment(text) {
      return moment(text).format('HH:mm');
    },
    shorten(text) {
      if (text.length > 24) {
        return text.substring(0, 24) + '...';
      }
      return text;
    }
  },
  mounted() {
    var _this = this;
    
    $(document).foundation();
    $('header').show();

    if (!this.$cookie.get('downloaded')) {
        _this.$router.push({
            name: 'default'
        });
    } else {
      var today = moment(new Date());
      window['user'] = JSON.parse(this.$cookie.get('user'));
      this.selectedUser = window['user'];
      window['apikey'] = this.$cookie.get('apikey');

      DAL.getItem('MTUsers', 'users').then(function (result) {
        if(result == null) {
          console.log("Kunne ikke finde nogle brugere i IDB");
        } else {
          _this.users = result;
        }
      })

      // get tasks for the given date
      this.getTasksFromIDB(window['selectedDate'], window['user'].id);
    }
  }
}
</script>


// WEBPACK FOOTER //
// projekter.vue?f5da0b82